export default {
    billingTerms: {
        helpText: '(This plan only supports monthly payment)',
        monthly: 'Monthly Payment',
        yearly: 'Yearly Payment',
        yearlyWithTwoMonthsFree: 'Yearly Payment <0>Two Months Free</0>',
    },
    checkboxes: {
        app: {
            akinaiBugyoIntegration: 'Akinai Bugyo App',
            customCsvIntegration: 'Custom CSV Import',
            ipAddressRestriction: 'IP Address Restriction',
            kanjoBugyoIntegration: 'Kanjo Bugyo App',
            kintoneIntegration: 'kintone Integration',
            pcaDxIntegration: 'PCA Kaikei DX App',
            pdfImporterIntegration: 'PDF Batch Sending',
            shokonIntegration: 'PCA Shokon DX App',
            voucherStorageIntegration:
                'Electronic Voucher Storage Service Integration',
        },
        options: {
            customDomain: 'Custom Email Domain',
            ml4sf: 'MakeLeaps for Salesforce',
            rakutenVa: 'Virtual Accounts',
        },
    },
    enterprise: {
        clientsHelpText: 'Unlimited',
        description:
            'Affordable pricing plan with no limits to the number of team members and clients. Extend advanced invoicing operations to your tens of thousands clients effectively with MakeLeaps for Enterprise.',
        sendingOrders: 'Sending Orders',
        sendingOrdersHelpText:
            '300 free sending orders monthly, then 30 yen/order beyond that. In addition to the sending order fee, you will need MailPoints to send documents via Japan Post. To avoid unexpected charges, please set a limit below. Sending limits can be adjusted at any time.',
        sendingOrdersLimit:
            'Sending Order Limit ({{value}} sent already this month)',
        teamMembersHelpText: 'Unlimited',
    },
    individual: {
        description:
            'The MakeLeaps Individual Plan gives you up to 3 users, 10 clients and access to all our document types, starting at only ¥500/User.',
        teamMembersHelpText: '¥500/Team Member/Month',
        warning:
            'Need more than 3 users? Upgrade to our MakeLeaps Organization Plan',
    },
    organization: {
        clientsHelpText:
            'first 10 free, then at a <0>decreasing per-client rate</0>',
        description:
            'Enable your whole company to coordinate and collaborate with MakeLeaps for Organizations. Automate your entire invoicing workflow and easily manage invoicing and billing for all of your customers.',
        teamMembersHelpText: '¥800/Team Member/Month',
    },
    shared: {
        activeClients: 'Active Clients',
        billingDetails: 'Billing Details',
        billingFrequency: 'Billing Frequency',
        billingFrequencyHelpText: '(This plan only supports monthly payment)',
        buyMailPoints: 'Buy MailPoints',
        changeSubscription: 'Change Subscription',
        enterprise: 'Enterprise',
        error: 'Error',
        findOutMore: 'Find out more',
        freeForLimitedTime:
            'Free for <0>limited use</0>. 20% off available for <1>charities</1> on request.',
        individual: 'Individual',
        integrations: 'Integrations',
        loading: 'Loading',
        options: 'Options <0>(Find out more)</0>',
        organization: 'Organization',
        plusTax: '{{value}} (+ Tax)',
        pricePerMonth: '({{value}}/Month)',
        subscribe: 'Subscribe',
        teamMembers: 'Team Members',
    },
};
